export const CashierManagement = () => {
  return <div>CashierManagement</div>
}
